import { DropDownConfig } from '../models/multiselect-dropdown.model';

export const CATEGORY_DROPDOWN_CONFIG: DropDownConfig = {
  allowSearchFilter: true,
  title: 'Categories',
  placeholder: 'Select Category',
  searchPlaceholderText: '',
  allowPagination: true,
  required: true,
};
export const AUTHOR_DROPDOWN_CONFIG: DropDownConfig = {
  allowSearchFilter: true,
  title: 'Author',
  placeholder: 'Select Author',
  searchPlaceholderText: '',
  allowPagination: true,
  required: true,
};
